'use client';

import { useConsentUpgradeReload } from './use-consent-upgrade-reload';

/**
 * Mount point for the one-shot reload that applies a mid-session accept to vendors which can only
 * be configured once per pageview (Segment's `load()`, PostHog's `init()`).
 */
export function ConsentUpgradeReload() {
  useConsentUpgradeReload();
  return null;
}